import {
  CalendarToday,
  Email,
  LocationOn,
  Phone,
  Wc,
} from "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import Iconify from "../../components/iconify/Iconify";
import { getCustomerDetails } from "../../reduxStore/slices/customerSlice";
import { useNotify } from "../../utils/snackbarUtils";

// Helper for Tab Panels
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
}

export default function CustomerView() {
  const { uid } = useParams();
  const { showSuccess, handleApiError, showError } = useNotify();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const storeId = user?.storeId;
  const [tab, setTab] = useState(0);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [customerDetails, setCustomerDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchCustomerDetails = async () => {
    setLoading(true);
    try {
      const customerData = await dispatch(
        getCustomerDetails({ storeId, uid }),
      ).unwrap();
      if (customerData) {
        setCustomerDetails(customerData);
      } else {
        showError("Customer not found");
      }
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (uid) {
      fetchCustomerDetails();
    }
  }, [uid]);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };
  
  const statusColors = {
    Ready: { label: "Ready", color: "success" },
    "In Progress": { label: "In Progress", color: "warning" },
    Completed: { label: "Completed", color: "default" },
  };

  const customer = {
    name: "Rajendra",
    mobile: "434344",
    email: "johndoe@gmail.com",
    city: "Mumbai",
    address: "123 Main Street, New Delhi, India",
    dob: "12 Jan 1990",
    gender: "Male",
    createdAt: "12 Jan 2023",
  };

  const orders = [
    {
      id: "925",
      table: "A4",
      name: "Ariel Hikmat",
      type: "Dine In",
      status: "Ready",
      statusNote: "Ready to serve",
      date: "Wed, July 12, 2023",
      time: "06:12 PM",
      items: [
        {
          name: "Smoked Salmon Bagel with Extra Cream Cheese",
          qty: 1,
          price: 16.99,
        },
        { name: "Smoked Salmon Bagel", qty: 1, price: 18.49 },
        { name: "Belgian Waffles", qty: 2, price: 38.98 },
        { name: "Classic Lemonade", qty: 1, price: 12.49 },
      ],
      total: 87.34,
    },
    {
      id: "921",
      table: "B2",
      name: "Denis Freeman",
      type: "Dine In",
      status: "In Progress",
      statusNote: "Cooking Now",
      date: "Wed, July 12, 2023",
      time: "06:18 PM",
      items: [
        { name: "Classic Cheeseburger", qty: 1, price: 10.99 },
        { name: "Fish and Chips", qty: 2, price: 34.0 },
        { name: "Greek Gyro Plate", qty: 1, price: 13.99 },
      ],
      total: 57.87,
    },
    {
      id: "912",
      table: "A9",
      name: "Maja Becker",
      type: "Dine In",
      status: "Completed",
      statusNote: "Waiting For Payment",
      date: "Wed, July 12, 2023",
      time: "05:32 PM",
      items: [
        { name: "Feta Stuffed Mushrooms", qty: 1, price: 18.99 },
        { name: "Lobster Ravioli", qty: 1, price: 17.99 },
        { name: "Thai Coconut Curry", qty: 2, price: 28.98 },
        { name: "Belgian Waffles", qty: 2, price: 25.98 },
      ],
      total: 98.34,
    },
    {
      id: "912",
      table: "A9",
      name: "Maja Becker",
      type: "Dine In",
      status: "Completed",
      statusNote: "Waiting For Payment",
      date: "Wed, July 12, 2023",
      time: "05:32 PM",
      items: [
        { name: "Feta Stuffed Mushrooms", qty: 1, price: 18.99 },
        { name: "Lobster Ravioli", qty: 1, price: 17.99 },
        { name: "Thai Coconut Curry", qty: 2, price: 28.98 },
        { name: "Belgian Waffles", qty: 2, price: 25.98 },
      ],
      total: 98.34,
    },
    {
      id: "912",
      table: "A9",
      name: "Maja Becker",
      type: "Dine In",
      status: "Completed",
      statusNote: "Waiting For Payment",
      date: "Wed, July 12, 2023",
      time: "05:32 PM",
      items: [
        { name: "Feta Stuffed Mushrooms", qty: 1, price: 18.99 },
        { name: "Lobster Ravioli", qty: 1, price: 17.99 },
        { name: "Thai Coconut Curry", qty: 2, price: 28.98 },
        { name: "Belgian Waffles", qty: 2, price: 25.98 },
      ],
      total: 98.34,
    },
    {
      id: "912",
      table: "A9",
      name: "Maja Becker",
      type: "Dine In",
      status: "Completed",
      statusNote: "Waiting For Payment",
      date: "Wed, July 12, 2023",
      time: "05:32 PM",
      items: [
        { name: "Feta Stuffed Mushrooms", qty: 1, price: 18.99 },
        { name: "Lobster Ravioli", qty: 1, price: 17.99 },
        { name: "Thai Coconut Curry", qty: 2, price: 28.98 },
        { name: "Belgian Waffles", qty: 2, price: 25.98 },
      ],
      total: 98.34,
    },
    {
      id: "912",
      table: "A9",
      name: "Maja Becker",
      type: "Dine In",
      status: "Completed",
      statusNote: "Waiting For Payment",
      date: "Wed, July 12, 2023",
      time: "05:32 PM",
      items: [
        { name: "Feta Stuffed Mushrooms", qty: 1, price: 18.99 },
        { name: "Lobster Ravioli", qty: 1, price: 17.99 },
        { name: "Thai Coconut Curry", qty: 2, price: 28.98 },
        { name: "Belgian Waffles", qty: 2, price: 25.98 },
      ],
      total: 98.34,
    },
  ];

  return (
    <>
      <Helmet>
        <title> View Customer | TrueMenu</title>
      </Helmet>
      <Box
        sx={{
          margin: "25px 60px",
        }}
      >
        <Stack mb={3}>
          <Box
            sx={{
              display: "flex",
              gap: 1,
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Typography variant="h5" gutterBottom>
              <Link style={{ textDecoration: "none" }} to="/app/customers">
                <IconButton>
                  <Iconify width={24} icon="eva:arrow-back-outline" />
                </IconButton>
              </Link>
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Box>
                <Avatar sx={{ bgcolor: "primary.main" }}>
                  {customer.name[0]}
                </Avatar>
              </Box>
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <Typography variant="h6">{customer.name}</Typography>
                  <Tooltip title="Edit">
                    <IconButton>
                      <Iconify icon={"eva:edit-fill"} />
                    </IconButton>
                  </Tooltip>
                </Box>
                <Typography variant="body2" color="text.secondary">
                  {customer.mobile} • {customer.email}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Stack>
        <Box>
          {/* Tabs */}
          <Tabs
            value={tab}
            onChange={handleTabChange}
            aria-label="customer tabs"
          >
            <Tab label="Customer Info" />
            {/* <Tab
              label={
                <Box display="flex" alignItems="center" gap={1}>
                  Orders
                  <Chip
                    label={"12"}
                    size="small"
                    sx={{
                      height: 20,
                      minWidth: 20,
                      fontSize: "0.75rem",
                      borderRadius: "10px",
                      bgcolor: "#1976d2",
                      color: "white",
                    }}
                  />
                </Box>
              }
            /> */}
          </Tabs>

          {/* Customer Info Tab */}
          <TabPanel value={tab} index={0}>
            <Card sx={{ borderRadius: 3, boxShadow: 3, p: 2 }}>
              <CardContent>
                <Grid
                  container
                  spacing={2}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                  >
                    <Typography variant="subtitle2" color="text.secondary">
                      Name
                    </Typography>
                    <Typography variant="body1">{customer.name}</Typography>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                  >
                    <Typography variant="subtitle2" color="text.secondary">
                      Mobile
                    </Typography>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Phone fontSize="small" color="primary" />
                      <Typography variant="body1">{customer.mobile}</Typography>
                    </Box>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                  >
                    <Typography variant="subtitle2" color="text.secondary">
                      Email
                    </Typography>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Email fontSize="small" color="primary" />
                      <Typography variant="body1">{customer.email}</Typography>
                    </Box>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                  >
                    <Typography variant="subtitle2" color="text.secondary">
                      Address
                    </Typography>
                    <Box display="flex" alignItems="center" gap={1}>
                      <LocationOn fontSize="small" color="primary" />
                      <Typography variant="body1">
                        {customer.address}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                  >
                    <Typography variant="subtitle2" color="text.secondary">
                      Date of Birth
                    </Typography>
                    <Box display="flex" alignItems="center" gap={1}>
                      <CalendarToday fontSize="small" color="primary" />
                      <Typography variant="body1">{customer.dob}</Typography>
                    </Box>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                  >
                    <Typography variant="subtitle2" color="text.secondary">
                      Gender
                    </Typography>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Wc fontSize="small" color="primary" />
                      <Typography variant="body1">{customer.gender}</Typography>
                    </Box>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                  >
                    <Typography variant="subtitle2" color="text.secondary">
                      City
                    </Typography>
                    <Typography variant="body1">{customer.city}</Typography>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                  >
                    <Typography variant="subtitle2" color="text.secondary">
                      Created At
                    </Typography>
                    <Typography variant="body1">
                      {customer.createdAt}
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </TabPanel>

          {/* Orders Tab */}
          <TabPanel value={tab} index={1}>
            <Box mb={4} maxWidth="900px" margin="0 auto">
              <Box
                display="flex"
                alignItems="center"
                justifyContent="flex-end"
                gap={1}
                sx={{ marginTop: "10px", marginBottom: "20px" }}
              >
                <TextField
                  size="small"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Search by order ID"
                  sx={{ width: 250, bgcolor: "#fff", borderRadius: 2 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>

              <Box>
                <List
                  sx={{
                    width: "100%",
                    bgcolor: "background.paper",
                    borderRadius: "10px",
                  }}
                >
                  {orders.map((order) => (
                    <React.Fragment key={order.id}>
                      <ListItem
                        alignItems="flex-start"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Box display="flex" alignItems="center" gap={1.5}>
                          <ListItemAvatar>
                            <Avatar
                              variant="rounded"
                              sx={{ bgcolor: "grey.800" }}
                            >
                              {order.table}
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary={
                              <Box display="flex" alignItems="center" gap={1}>
                                <Typography
                                  variant="subtitle1"
                                  fontWeight={600}
                                >
                                  #{order.id} / {order.type}
                                </Typography>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    style={{
                                      background: "rgb(0, 171, 85)",
                                      color: "#fff",
                                      fontSize: "12px",
                                      borderRadius: "10px",
                                      padding: "2px 5px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    10 min
                                  </Typography>
                                  <Chip
                                    label={statusColors[order.status]?.label}
                                    color={statusColors[order.status]?.color}
                                    variant="outlined"
                                    size="small"
                                    sx={{ fontWeight: 500 }}
                                  />
                                </Box>
                              </Box>
                            }
                            secondary={
                              <>
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  gap="10px"
                                >
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                  >
                                    <Chip label="Rooftop" size="small" />
                                  </Typography>

                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    • Ready to serve
                                  </Typography>
                                </Box>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  {order.date} • {order.time}
                                </Typography>
                              </>
                            }
                          />
                        </Box>

                        {/* Right side (Qty + Total + Buttons) */}
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="flex-end"
                          gap={1}
                        >
                          <Typography variant="body2" color="text.secondary">
                            Qty: {"5"} &nbsp; | &nbsp; Total Amount:{" "}
                            <b>${order.total.toFixed(2)}</b>
                          </Typography>

                          <Box display="flex" gap={1}>
                            <Button variant="outlined" size="small">
                              See Details
                            </Button>
                            <Button
                              variant="contained"
                              size="small"
                              color="warning"
                            >
                              Pay Bills
                            </Button>
                          </Box>
                        </Box>
                      </ListItem>
                      <Divider component="li" />
                    </React.Fragment>
                  ))}
                </List>
              </Box>
            </Box>
          </TabPanel>
        </Box>
      </Box>
    </>
  );
}
